import React, {useEffect} from "react";
import Header from "components/Header";
import Event from "components/Event";
import Hero from "components/Hero";
import Vote from "components/Vote";
import Footer from "components/Footer";
import HeroTicker from "components/HeroTicker";

const MainVote: React.FC = () => {
    const [isHiddenHeader, setIsHiddenHeader] = React.useState<boolean>(false);
    const [isHiddenEvent, setIsHiddenEvent] = React.useState<boolean>(false);

    const showHeader = (scrollY: number) => {
        if (scrollY > 10) {
            setIsHiddenHeader(true);
            setIsHiddenEvent(true);
        } else {
            setIsHiddenHeader(false);
            setIsHiddenEvent(false);
        }
    };

    const scrollEvent = () => {
        showHeader(window.scrollY);
    };

    useEffect(() => {
        window.addEventListener('scroll', scrollEvent);

        return () => window.removeEventListener('scroll', scrollEvent);
    }, []);

    return (
        <>
            <Header isHidden={isHiddenHeader}/>
            <Event isHidden={isHiddenEvent}/>
            <Hero/>
            {/* <HeroTicker/> */}
            <Vote/>
            <Footer/>
        </>
    );
};

export default MainVote;